import { useCallback, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { canViewRestaurantDirectory, getRestaurantDirectory } from '../services/RestaurantDirectory';

// No shared cache: account changes and late requests cannot reveal old results.
export const useRestaurantDirectory = () => {
  const user = useSelector((state) => state.user.user);
  const owner = user?.id;
  const allowed = owner != null && canViewRestaurantDirectory(user);
  const generation = useRef(0);
  const [state, setState] = useState({ isFetching: true });
  const refetch = useCallback(async () => {
    const request = ++generation.current;
    setState((old) => ({
      owner, isFetching: allowed,
      dataUpdatedAt: old.owner === owner ? old.dataUpdatedAt : undefined,
    }));
    if (!allowed) return;
    try {
      const data = await getRestaurantDirectory();
      if (generation.current === request) {
        setState({ owner, data, isFetching: false, dataUpdatedAt: Date.now() });
      }
    } catch (error) {
      if (generation.current === request) {
        setState((old) => ({ ...old, data: undefined, error, isFetching: false }));
      }
    }
  }, [owner, allowed]);
  useEffect(() => {
    refetch();
    return () => { generation.current += 1; };
  }, [refetch]);
  return {
    ...(allowed && state.owner === owner ? state : { isFetching: allowed }),
    refetch,
  };
};
